<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="box-container">
  @for (boxStatus of boxes(); track $index) {
    @if (boxStatus.filled) {
      <div
        (click)="select($index)"
        class="box"
        [style.background-color]="icfColor()"
        [style.color]="boxStatus.last ? 'black' : '#ababab70'">
        {{ $index }}
      </div>
    } @else {
      <div (click)="select($index)" class="box empty">{{ $index }}</div>
    }
  }
  @if (icfSelectedByUser() > -1) {
    <button class="minimal-icon-button no-print" (click)="remove()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
<p class="description top">{{ icfSelectedByUser() | icfDescription: 1 }}</p>
<p class="description">{{ icfSelectedByUser() | icfDescription: 2 }}</p>
<div class="averageDescription">
  <div>Durchschnitt Assessments: {{ valuePercent() }} %</div>
  @if (valueIcf() !== icfSelectedByUser()) {
    <button class="link-style no-print" (click)="selectGeneratedIcf()" title="Übernimmt den errechneten ICF Score">
      Als ICF Score übernehmen
    </button>
  }
</div>
